// What a bike's card in the walk-through shop says (bike plan 5), pure so node tests cover it.
// Built on bikeOffer: the design and its level and price, a speed bar, and one action — Kup, or Sprzedaj when
// you own that design (one of each design, bike plan 6). The bike you are riding can't be sold from under you.
import { bikeOffer } from './bikeOffer.mjs';
import { BIKE_SPEED } from './bikeRide.mjs';

export function bikeCard(raw, type, design, ridingId = null) {
  const o = bikeOffer(raw, type, design);
  const actions = !o.owned
    ? [{
      kind: 'buy',
      label: o.price == null ? 'Kup' : `Kup za ${o.price} {coin}${o.block === 'money' ? ' — za mało {coin}' : ''}`,
      disabled: o.block !== null,
    }]
    : design === ridingId
      ? [{ kind: 'sell', label: 'Najpierw zsiądź z tego rowerka {bike}', disabled: true }]
      : [{ kind: 'sell', label: `Sprzedaj za ${o.sellPrice} {coin}`, disabled: false }];
  return {
    title: o.designName ?? 'Rowerek',
    subtitle: o.level ? `${o.name} · ${o.level}` : o.name,
    note: o.owned ? 'Masz już ten rowerek' : null,
    // The greased top speed: the same for every design of a bike, the blue one the fastest.
    speedShare: BIKE_SPEED[type] / BIKE_SPEED.blue,
    price: o.price,
    actions,
    offer: o,
  };
}
